import axios from 'axios';

//API가 401(세션 만료)을 응답하면 전역에서 한 번만 안내한다.
//세션은 서버에서 이미 소멸한 상태라 재시도로는 복구되지 않으므로 재입장 안내가 유일한 처리다.
//학습 화면은 API를 동시에 여러 개 호출하므로 alerted 플래그로 알림 폭주를 막는다.
let alerted = false;

//공용 PC: 같은 브라우저에서 다른 학생이 학습창을 열면 세션의 학생이 바뀐다.
//서버는 요청의 X-ITC-Mem(이 창의 학생 번호)과 세션의 학생이 다르면 409 USER_CHANGED 로 응답한다.
const USER_CHANGED_TITLE = '로그인 정보가 바뀌었습니다';
const USER_CHANGED_DETAIL = '이 PC에서 다른 학생이 학습창을 열었습니다.<br>' +
    '이 창을 닫고, 홈페이지에서 본인 계정으로 다시 로그인한 뒤<br>[학습하기] 버튼으로 입장해 주세요.<br>' +
    '진행한 학습은 저장되어 있어 이어서 학습할 수 있습니다.';
const USER_CHANGED_ALERT = '이 PC에서 다른 학생이 학습창을 열어 로그인 정보가 바뀌었습니다.\n' +
    '이 창을 닫고 홈페이지에서 본인 계정으로 다시 입장해 주세요.';

//화면 전체를 안내로 덮는다. window.close()가 브라우저에 막혀 창이 남더라도
//깨진 앱을 계속 조작하는 "좀비 창"이 되지 않게 하는 최후 방어선.
//React 상태와 무관하게 동작해야 하므로 raw DOM으로 그린다.
export function showFatalOverlay(title, detail) {
    if (document.getElementById('auth-guard-overlay')) {
        return;
    }

    const el = document.createElement('div');
    el.id = 'auth-guard-overlay';
    el.style.cssText = 'position:fixed;top:0;left:0;right:0;bottom:0;z-index:2147483647;' +
        'background:#fff;display:flex;flex-direction:column;align-items:center;justify-content:center;' +
        'font-family:sans-serif;text-align:center;padding:20px;';
    el.innerHTML = '<h2 style="margin:0 0 14px;font-size:24px;">' + title + '</h2>' +
        '<p style="margin:0;font-size:16px;color:#555;line-height:1.7;">' + detail + '</p>';

    if (document.body) {
        document.body.appendChild(el);
    }
}

//우리 서버 API로 가는 요청인지. CDN 등 다른 출처로 가는 요청에 직접 만든 헤더를 실으면
//브라우저가 CORS 사전 요청을 보내고 그쪽이 거절할 수 있으므로, 같은 출처의 /api/ 요청에만 싣는다.
function isOwnApiRequest(url) {
    if (!url || url.indexOf('/api/') === -1) {
        return false;
    }

    if (url.indexOf('://') === -1) {
        return true;
    }

    return url.indexOf(window.location.origin + '/') === 0;
}

export default function installAuthGuard(message, onExpired) {
    //학습창이 열릴 때 서버가 넣어준 이 창의 학생 번호. 교사용처럼 학생 번호가 없으면 헤더를 싣지 않는다(서버도 검사 안 함).
    const serverData = window.serverData;
    const windowMemIdx = serverData && serverData.mem_idx !== undefined && serverData.mem_idx !== null && serverData.mem_idx !== ''
        ? String(serverData.mem_idx)
        : null;

    if (windowMemIdx) {
        axios.interceptors.request.use(function (config) {
            if (isOwnApiRequest(config.url)) {
                config.headers = config.headers || {};
                config.headers['X-ITC-Mem'] = windowMemIdx;
            }

            return config;
        });
    }

    axios.interceptors.response.use(
        function (response) {
            return response;
        },
        function (error) {
            const url = error.config && error.config.url ? error.config.url : '';
            const status = error.response && error.response.status;

            if (!alerted && url.indexOf('/api/') !== -1) {
                if (status === 401) {
                    alerted = true;
                    showFatalOverlay('로그인 정보가 만료되었습니다', message.replace(/\n/g, '<br>'));
                    alert(message);

                    if (onExpired) {
                        onExpired();
                    }
                } else if (status === 409 && error.response.data && error.response.data.code === 'USER_CHANGED') {
                    alerted = true;
                    showFatalOverlay(USER_CHANGED_TITLE, USER_CHANGED_DETAIL);
                    alert(USER_CHANGED_ALERT);

                    if (onExpired) {
                        onExpired();
                    }
                }
            }

            return Promise.reject(error);
        }
    );
}
